import { hideModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import { ContainerModalCentro } from "./localStyle";
import { FaMapMarkerAlt } from "react-icons/fa";
import { getLocalStorage } from "global/utils/safeJsonParse";

const ModalCentro = ({ item }) => {
  const { modalDispatch } = useContext(GlobalContext);
  const idTerminal = getLocalStorage("idTerminal");

  const handleComoLlegar = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${item.coordenadaGps}&dir_action=navigate&travelmode=walking`;
    // const url = `https://maps.google.com/?q=${item.coordenadaGps}`;
    window.open(url, "_blank");
  };

  return (
    <ContainerModalCentro>
      {idTerminal ? (
        <>
          <p className="rb18l text-center">
            Estás en una sede diferente a la del turno seleccionado. Dirigite a
            la sede correspondiente para comenzar con el proceso de recepción.
          </p>
          <p className="rb18m">Sede seleccionada:</p>
          <div className="container-direccion">
            <FaMapMarkerAlt color={"var(--color-latex30)"} size={24} />{" "}
            {/* <p className="rb18m">{item?.direccion}</p> */}
            <p className="rb18m">{item?.centro}</p>
          </div>
        </>
      ) : (
        <>
          <p>
            Estás en una sede diferente a la del turno. Para poder
            recepcionarte, seguí estos pasos:
          </p>
          <p>
            1) Tocá "¿Cómo llegar?" para ver la ubicación.
            <br />
            2) Cuando llegues, escaneá el código QR para comenzar la recepción.
          </p>
          <span className="bold btn-como-llegar" onClick={handleComoLlegar}>
            <FaMapMarkerAlt color={"var(--color-latex30)"} size={20} /> ¿Cómo
            llegar?
          </span>

          <div className="container-btn">
            <button
              className="bgc-primary cancelar"
              onClick={() => hideModal()(modalDispatch)}
            >
              Cerrar
            </button>
          </div>
        </>
      )}
    </ContainerModalCentro>
  );
};
export default ModalCentro;
